module.exports = __webpack_public_path__ + "img/9788934991151.de41b2ed.jpg";